import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpUtils } from "../shared/http.utils";
import { OrganizationsResponse } from "../model/responses/organizations-response";
import { BasicFilters } from "../model/filters/basic-filters";
import { OrganizationPersistRequest } from "../model/requests/organization-persist-request";
import { AssetFilters } from "../model/filters/asset-filters";
import { AssetsResponse } from "../model/responses/assets-response";
import { DeviceFilters } from "../model/filters/device-filters";
import { DevicesResponse } from "../model/responses/devices-response";
import {EntityFilters} from "../model/filters/entity-filters";

@Injectable({
  providedIn: 'root'
})
export class OrganizationsService {

  private readonly organizationsURL: string;

  constructor(private http: HttpClient) {
    this.organizationsURL = "/catalog/organizations";
  }

  public getOrganizations(offset?: number, limit?: number, filters?: BasicFilters): Observable<OrganizationsResponse>{
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new BasicFilters();
    return this.http.post<OrganizationsResponse>(this.organizationsURL, body, options);
  }

  public getOrganization(organizationUuid: string) {
    let url = `${this.organizationsURL}/${organizationUuid}`;
    return this.http.get<any>(url);
  }

  public getOrganizationDevices(organizationUuid: string, offset?: number, limit?: number, filters?: DeviceFilters): Observable<DevicesResponse> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let url = `${this.organizationsURL}/${organizationUuid}/devices`;
    let body = (filters != null) ? filters : new DeviceFilters();
    return this.http.post<any>(url, body, options);
  }

  public getOrganizationDevicesSummaries(organizationUuid: string) {
    let url = `${this.organizationsURL}/${organizationUuid}/summaries/devices`;
    return this.http.get<any>(url);
  }

  public getOrganizationAssets(organizationUuid: string, offset?: number, limit?: number, filters?: AssetFilters): Observable<AssetsResponse> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let url = `${this.organizationsURL}/${organizationUuid}/assets`;
    let body = (filters != null) ? filters : new AssetFilters();
    return this.http.post<any>(url, body, options);
  }

  public getOrganizationAssetsSummaries(organizationUuid: string) {
    let url = `${this.organizationsURL}/${organizationUuid}/summaries/assets`;
    return this.http.get<any>(url);
  }

  public createOrganization(creationData: OrganizationPersistRequest) {
    let url = `${this.organizationsURL}/create`;
    return this.http.post<any>(url, creationData);
  }

  public editOrganization(editionData: OrganizationPersistRequest) {
    let url = `${this.organizationsURL}/edit`;
    return this.http.post<any>(url, editionData);
  }

  public deleteOrganization(organizationUuid: string) {
    let url = `${this.organizationsURL}/${organizationUuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteOrganizations(uuids: {uuid: string}[]) {
    let url = `${this.organizationsURL}/delete`;
    return this.http.post<any>(url, uuids, {observe: 'response'});
  }

  public getOrganizationEntitiesFromMeasurement(organizationUuid: string, offset?: number, limit?: number, filters?: EntityFilters): Observable<any> {
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const url = `${this.organizationsURL}/${organizationUuid}/entities_from_measurement`;
    const body = (filters != null) ? filters : new EntityFilters();
    return this.http.post<any>(url, body, options);
  }
}
